import { DatabaseService } from './database.service';
import { Injectable } from '@angular/core';
import { AlertController } from '@ionic/angular';
import { ObserverService } from './observer.service';
import { StorageService } from './storage.service';

@Injectable()
export class SupportedCurrencyService {

    constructor(
        public alertController: AlertController,
        private observerService: ObserverService,
        private databaseService: DatabaseService,
        private storageService: StorageService
    ) { }

    addSupportedCurrency(raw_supported_currency) {
        return new Promise<void>((resolve, reject) => {
            let supported_currency = {};
            supported_currency['id'] = raw_supported_currency.id;
            supported_currency['code'] = raw_supported_currency.code;
            supported_currency['base'] = raw_supported_currency.base;
            supported_currency['sign'] = raw_supported_currency.sign;
            supported_currency['title'] = raw_supported_currency.title;
            if (raw_supported_currency.cash_rounding_mode) {
                supported_currency['cash_rounding_mode'] = raw_supported_currency.cash_rounding_mode;
            }
            this.databaseService.supported_currency.add(supported_currency).then(() => {
                this.observerService.publish("supported_currency_added", supported_currency);
                this.storageService.set("supported_currencies_last_updated_date", new Date().toISOString()).then(() => {}).catch(() => {});
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    bulkAddSupportedCurrencies(raw_supported_currencies) {
        return new Promise<void>((resolve, reject) => {
            if(raw_supported_currencies !== undefined) {
                this.databaseService.supported_currency.clear().then(async () => {
                    let supported_currencies = [];
                    for (let i = 0; i < raw_supported_currencies.length; i++) {
                        let supported_currency = {};
                        supported_currency["id"] = raw_supported_currencies[i].id;
                        supported_currency["code"] = raw_supported_currencies[i].code;
                        supported_currency["base"] = raw_supported_currencies[i].base;
                        supported_currency["sign"] = raw_supported_currencies[i].sign;
                        supported_currency["title"] = raw_supported_currencies[i].title;
                        if (raw_supported_currencies[i].cash_rounding_mode) {
                            supported_currency['cash_rounding_mode'] = raw_supported_currencies[i].cash_rounding_mode;
                        }
                        supported_currencies.push(supported_currency);
                    }
                    await this.databaseService.supported_currency.bulkAdd(supported_currencies).then(() => {
                        this.observerService.publish("supported_currencies_changed", supported_currencies);
                        this.storageService.set("supported_currencies_last_updated_date", new Date().toISOString()).then(() => { }).catch(() => { });
                        resolve();
                    })
                    .catch(() => {
                        reject();
                    });
                })
                .catch(() => {
                    reject();
                });
            }
            else {
                resolve();
            }
        });
    }

    deleteSupportedCurrency(supported_currency) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.supported_currency.delete(supported_currency.id).then(() => {
                this.observerService.publish("supported_currency_deleted", supported_currency);
                this.storageService.set("supported_currencies_last_updated_date", new Date().toISOString()).then(() => {}).catch(() => {});
                resolve();
            })
            .catch(() => {
                reject();
            });
        });
    }

    getBaseSupportedCurrency() {
        return new Promise((resolve, reject) => {
            this.databaseService.supported_currency.toArray().then((supported_currencies) => {
                for(let i = 0; i < supported_currencies.length; i++) {
                    if(supported_currencies[i].base == true) {
                        resolve(supported_currencies[i]);
                    }
                }
            })
            .catch(() => {
                reject();
            });
        });
    }

    getSupportedCurrency(supported_currency_id) {
        return new Promise((resolve, reject) => {
            this.databaseService.supported_currency.get(supported_currency_id).then((supported_currency) => {
                resolve(supported_currency);
            })
            .catch(() => {
                reject();
            });
        });
    }

    getSupportedCurrencies() {
        return new Promise((resolve, reject) => {
            this.databaseService.supported_currency.toArray().then((supported_currencies) => {
                resolve(supported_currencies);
            })
            .catch(() => {
                reject();
            });
        });
    }

    updateSupportedCurrency(raw_supported_currency) {
        return new Promise<void>((resolve, reject) => {
            this.databaseService.supported_currency.delete(raw_supported_currency.id).then(() => {
                let supported_currency = {};
                supported_currency["id"] = raw_supported_currency.id;
                supported_currency["code"] = raw_supported_currency.code;
                supported_currency["base"] = raw_supported_currency.base;
                supported_currency["sign"] = raw_supported_currency.sign;
                supported_currency["title"] = raw_supported_currency.title;
                if(raw_supported_currency.cash_rounding_mode) {
                    supported_currency['cash_rounding_mode'] = raw_supported_currency.cash_rounding_mode;
                }
                this.databaseService.supported_currency.add(supported_currency).then(() => {
                    this.observerService.publish("supported_currency_updated", supported_currency);
                    this.storageService.set("supported_currencies_last_updated_date", new Date().toISOString()).then(() => { }).catch(() => { });
                    resolve();
                })
                .catch(() => {
                    reject();
                });
            })
            .catch(() => {
                reject();
            });
        });
    }

}
